<template>
  <v-container>
    <v-row>
      <v-col>
        <h4 class="display-1"> {{ $t('conceptualFrameworks.edit') }} </h4>
      </v-col>
    </v-row>
    <v-card class="px-4">
      <ValidationObserver
        v-slot="{ handleSubmit }"
      >
        <form @submit.prevent="saveConceptualFramework">
          <v-row>
            <v-col cols="12">
              <x-inputs-input
                :input="form.name"
                @updateInput="($event) => form.name = $event"
                :label="$t('input.name')"
                rules="required"
                autofocus
                light
                name="name"
              />
            </v-col>
            <template v-if="$route.params.slug !== 'base-conceptual-framework'">
              <v-col cols="12" sm="6">
                <x-inputs-autocomplete
                  :items="assignationTypes"
                  :input="form.assignationType"
                  @updateInput="($event) => form.assignationType = $event"
                  clearable
                  light
                  :label="$t('conceptualFrameworks.asignation_type')"
                  name="assign_type"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <x-inputs-autocomplete
                  :items="assignations"
                  :input="form.assignationFor"
                  @updateInput="($event) => form.assignationFor = $event"
                  light
                  :label="$t('conceptualFrameworks.assign_to')"
                  name="assign_for"
                  :rules="form.assignationType ? 'required' : ''"
                />
              </v-col>
            </template>
          </v-row>
          <v-row>
            <v-col align="end">
              <v-btn
                text
                to="/conceptual_frameworks"
              >
                {{ $t('input.cancel') }}
              </v-btn>
              <v-btn
                type="submit"
                color="primary"
              >
                {{ $t('input.save') }}
              </v-btn>
            </v-col>
          </v-row>
        </form>
      </ValidationObserver>
    </v-card>
  </v-container>
</template>

<script>
import Vue from 'vue'

import resolver from '../../utils/resolver'

import conceptualFrameworksService from '../../services/conceptual-frameworks'
import customersService from '../../services/customers'
import sectorsService from '../../services/sectors'

export default Vue.extend({
  data () {
    return {
      form: {
        name: '',
        assignationType: '',
        assignationFor: ''
      },
      assignationTypes: [
        { text: '', value: 'customer' },
        { text: '', value: 'enterprise' },
        { text: '', value: 'sector' }
      ],
      customersResponse: [],
      sectorsRespone: []
    }
  },
  created () {
    this.assignationTypes.forEach(assignation => { assignation.text = this.$t(`conceptualFrameworks.${assignation.value}`) })
    resolver
      .all({
        customers: customersService.shortListWithEnterprises(),
        sectors: sectorsService.list(),
        conceptual_framework: conceptualFrameworksService.getOne(this.$route.params.slug)
      })
      .then((res) => {
        this.customersResponse = res.customers
        this.sectorsRespone = res.sectors.items
        this.form.name = res.conceptual_framework.name
        this.form.assignationType = res.conceptual_framework.assignationType
        this.form.assignationFor = res.conceptual_framework.assignationFor
      })
  },
  computed: {
    assignations () {
      switch (this.form.assignationType) {
        case 'customer':
          return this.customersResponse.map((customer) => ({
            text: customer.name,
            value: customer.id
          }))
        case 'enterprise':
          const assignations = []
          for (const customer of this.customersResponse) {
            assignations.push({ header: customer.name })
            for (const enterprise of customer.enterprises) {
              assignations.push({
                text: enterprise.name,
                value: enterprise.id
              })
            }
            assignations.push({ divider: true })
          }
          return assignations
        case 'sector':
          return this.sectorsRespone.map((sector) => {
            return {
              text: sector.translate ? sector.translate.label : sector.code,
              value: sector.id
            }
          })
      }
      return []
    }
  },
  methods: {
    saveConceptualFramework () {
      return conceptualFrameworksService.updateInfo(this.$route.params.slug, this.form)
        .then((res) => {
          this.$store.dispatch('alert/success', this.$t('conceptualFrameworks.edited_succesfully'))
          this.$router.push('/conceptual_frameworks')
        }).catch((err) => {
          this.$store.dispatch('alert/success', this.$t('conceptualFrameworks.error_editing'))
          console.log('error', err)
        })
    }
  }
})
</script>
